/**
 * @generated SignedSource<<6ca638643d7e7ec51721f1f161221feb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentSourceDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePaymentSourceTPayload",
        "kind": "LinkedField",
        "name": "deletePaymentSourceTByPsId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceT",
            "kind": "LinkedField",
            "name": "paymentSourceT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentSourceDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePaymentSourceTPayload",
        "kind": "LinkedField",
        "name": "deletePaymentSourceTByPsId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceT",
            "kind": "LinkedField",
            "name": "paymentSourceT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "065cafa821f5b04b2dc37ab2c7800259",
    "id": null,
    "metadata": {},
    "name": "PaymentSourceDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentSourceDeleteMutation(\n  $input: DeletePaymentSourceTByPsIdInput!\n) {\n  deletePaymentSourceTByPsId(input: $input) {\n    paymentSourceT {\n      psId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d876de489df5304607993e7a3947ef62";

module.exports = node;
